import {ApolloClient, InMemoryCache} from "@apollo/client";

export const createApolloClient = () => new ApolloClient({
    cache: new InMemoryCache({addTypename: false}),
    uri: `${process.env.REACT_APP_SDN_API_BASE_URL}`,
    headers: {authorization: `Bearer ${localStorage.getItem('access_token')}`,}
})